if (!customElements.get('ess-offer-countdown')) {
  customElements.define('ess-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) clearInterval(this.interval);
      this.endsAt = Date.parse(this.dataset.endsAt);
      this.units = Object.fromEntries(Array.from(this.querySelectorAll('[data-time]'), el => [el.dataset.time, el]));
      const time = this.querySelector('time');
      if (time && Number.isFinite(this.endsAt)) {
        try {
          time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
            day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short'
          }).format(new Date(this.endsAt));
        } catch (_) {}
      }
      if (this.update()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
    }
    update() {
      const remaining = Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000));
      if (!Number.isFinite(remaining) || remaining === 0) {
        this.hidden = true;
        const card = this.closest('.ess-bundle-card');
        if (card) {
          card.classList.remove('ess-limited-card');
          const badge = card.querySelector('[data-ess-offer-badge]');
          if (badge) badge.hidden = true;
        }
        clearInterval(this.interval);
        this.interval = null;
        return false;
      }
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining % 86400 / 3600),
        minutes: Math.floor(remaining % 3600 / 60),
        seconds: remaining % 60
      };
      for (const [key, value] of Object.entries(values)) {
        const text = String(value).padStart(2, '0');
        if (this.units[key] && this.units[key].textContent !== text) this.units[key].textContent = text;
      }
      return true;
    }
  });
}

if (!customElements.get('ess-shampoo-flash-countdown')) {
  customElements.define('ess-shampoo-flash-countdown', class extends HTMLElement {
    static get observedAttributes() { return ['data-ends-at']; }

    static parseFixedDeadline(value) {
      const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|([+-])(\d{2}):(\d{2}))$/);
      if (!match) return NaN;
      const [, yearText, monthText, dayText, hourText, minuteText, secondText, zone, sign, zoneHourText, zoneMinuteText] = match;
      const year = Number(yearText), month = Number(monthText), day = Number(dayText);
      const hour = Number(hourText), minute = Number(minuteText), second = Number(secondText || 0);
      if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59 || second > 59) return NaN;
      const wallTime = Date.UTC(year, month - 1, day, hour, minute, second);
      const calendar = new Date(wallTime);
      if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
      const zoneHour = Number(zoneHourText || 0), zoneMinute = Number(zoneMinuteText || 0);
      if (zoneHour > 23 || zoneMinute > 59) return NaN;
      const offset = zone === 'Z' ? 0 : (sign === '-' ? -1 : 1) * (zoneHour * 60 + zoneMinute) * 60000;
      return wallTime - offset;
    }

    connectedCallback() {
      this.onClockVisible ||= () => { if (this.isConnected) this.update(); };
      document.addEventListener('visibilitychange', this.onClockVisible);
      window.addEventListener('pageshow', this.onClockVisible);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onClockVisible);
      window.removeEventListener('pageshow', this.onClockVisible);
    }

    attributeChangedCallback(name, previous, next) {
      if (previous !== next && this.isConnected) this.start();
    }

    stop() {
      if (this.interval != null) clearInterval(this.interval);
      this.interval = null;
    }

    start() {
      this.stop();
      this.endsAt = this.constructor.parseFixedDeadline(this.dataset.endsAt);
      this.units = Object.fromEntries(Array.from(this.querySelectorAll('[data-time]'), node => [node.dataset.time, node]));
      this.status = this.querySelector('[data-flash-status]');
      this.titleElement = this.querySelector('[data-flash-title]');
      const time = this.querySelector('[data-flash-deadline]');
      if (time && Number.isFinite(this.endsAt)) {
        try {
          time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
            day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short'
          }).format(new Date(this.endsAt));
        } catch (_) {}
      }
      if (this.update()) this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const valid = Number.isFinite(this.endsAt);
      const remaining = valid ? Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000)) : 0;
      const state = !valid ? 'invalid' : remaining === 0 ? 'expired' : 'active';
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) {
        const text = String(value).padStart(2, '0');
        if (this.units?.[unit] && this.units[unit].textContent !== text) this.units[unit].textContent = text;
      }
      this.dataset.state = state;
      const title = state === 'active' ? this.dataset.activeLabel : this.dataset.inactiveLabel;
      if (this.titleElement && this.titleElement.textContent !== title) this.titleElement.textContent = title;
      this.setAttribute('aria-label', title);
      if (this.status) {
        this.status.hidden = state === 'active';
        const text = state === 'invalid' ? this.dataset.invalidLabel : this.dataset.expiredLabel;
        if (state !== 'active' && this.status.textContent !== text) this.status.textContent = text;
      }
      if (state !== 'active') this.stop();
      return state === 'active';
    }
  });
}
